import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import coinLogo from '../../assets/COINLogo.png';
import { useAuth } from '../../contexts/AuthContext';
import AdminCardDetail from './AdminCardDetail';
import AdminCardSearch from './AdminCardSearch';
import AdminExclusions from './AdminExclusions';
import AdminScriptRuns from './AdminScriptRuns';
import AdminUsers from './AdminUsers';
import { fetchMeta } from './adminApi';
import './admin.css';

const TABS = [
  { id: 'cards', label: 'Card Search' },
  { id: 'exclusions', label: 'Exclusions' },
  { id: 'users', label: 'Users' },
  { id: 'runs', label: 'Script Runs' },
];

function AdminConsole() {
  const { user } = useAuth();
  const [tab, setTab] = useState('cards');
  const [meta, setMeta] = useState(null);
  const [metaError, setMetaError] = useState('');
  const [selectedCardId, setSelectedCardId] = useState(null);
  // Bumped when a removal lands, so the Exclusions tab reloads rather than
  // showing a stale list when the operator switches to it.
  const [exclusionsToken, setExclusionsToken] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    fetchMeta(controller.signal)
      .then(setMeta)
      .catch((error) => {
        if (error.name !== 'AbortError') setMetaError(error.message);
      });
    return () => controller.abort();
  }, []);

  const openCard = (cardId) => {
    setSelectedCardId(cardId);
    setTab('cards');
  };

  return (
    <div className="admin-console">
      <header className="admin-header">
        <div className="admin-header-brand">
          <img src={coinLogo} alt="COIN Logo" />
          <div>
            <h1>Admin Console</h1>
            <p className="admin-card-sub">{user?.email}</p>
          </div>
        </div>
        <Link to="/dashboard" className="admin-button">Back to Grading</Link>
      </header>

      {metaError && <p className="admin-error" role="alert">{metaError}</p>}
      {meta?.migration_pending && (
        <p className="admin-notice admin-notice--warning" role="status">
          <code>migrations/create_admin_console_tables.sql</code> has not been applied to this
          database. Search and raw data work, but removals and run history will not.
        </p>
      )}

      <nav className="admin-tabs" aria-label="Admin sections">
        {TABS.map((entry) => (
          <button
            key={entry.id}
            type="button"
            className={`admin-tab${tab === entry.id ? ' admin-tab--active' : ''}`}
            aria-current={tab === entry.id ? 'page' : undefined}
            onClick={() => { setTab(entry.id); if (entry.id !== 'cards') setSelectedCardId(null); }}
          >
            {entry.label}
          </button>
        ))}
      </nav>

      {tab === 'cards' && (
        selectedCardId ? (
          <AdminCardDetail cardId={selectedCardId} onBack={() => setSelectedCardId(null)} />
        ) : (
          <AdminCardSearch
            meta={meta}
            onViewCard={openCard}
            onExclusionCreated={() => setExclusionsToken((token) => token + 1)}
          />
        )
      )}
      {tab === 'exclusions' && <AdminExclusions refreshToken={exclusionsToken} />}
      {tab === 'users' && <AdminUsers />}
      {tab === 'runs' && <AdminScriptRuns />}
    </div>
  );
}

export default AdminConsole;
